module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"refer.from":"งานจาก","refer.to":"ถูกส่งต่อให้"}}')
  delete Component.options._Ctor
}
